export enum Roles {
    SUPER_ADMIN = 'SUPER-ADMIN',
    ADMIN = 'ADMIN',
    ARCHITECT = 'ARCHITECT',
    USER = 'USER',
    ESTIMATION_OFFICE = 'ESTIMATION_OFFICE'
}